import React from 'react';
import { Header } from './Header';
import { DisclaimerBar } from './DisclaimerBar';
import { StickyCTA } from './StickyCTA';
import { Footer } from './Footer';
import { LeadModal } from '../LeadModal';

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <DisclaimerBar />
      
      {/* Main content with padding for fixed header and disclaimer */}
      <main className="flex-1 pt-32">
        {children}
      </main>
      
      <Footer />
      <StickyCTA />
      
      {/* Global Lead Modal - opens via window event */}
      <LeadModal />
    </div>
  );
};
